import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

const theme = {
    primary: '#3682d8',
    secondary: '#3682d8',
    accent: '#3682d8',
    info: '#00CAE3',
    success: '#83b660',
    warning: '#ff9c44',
    error: '#f83636',

    background: '#f8f8f8',
    drawer: '#1565c0',

    requests: '#1256a2',
    impressions: '#1967bf',
    revenues: '#1256a2',
    fillRate: '#3682d8',
    clicks: '#1967bf',
    ctr: '#1256a2',
    viewability: '#1967bf',
    cpm: '#1967bf',
    rpm: '#3682d8'

};

export default new Vuetify({
    theme: {
        themes: {
            dark: theme,
            light: theme,
        },
    },

})
